function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "gDhs_GJdOvNXmd9k7HRk_a",
  x1: 23.02,
  x2: 25.063,
  y1: 4.362,
  y2: 18.044,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.042,
  stopColor: "#076db4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#0461af"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#gDhs_GJdOvNXmd9k7HRk_a)",
  d: "M42,14H6V8c0-1.105,0.895-2,2-2h32c1.105,0,2,0.895,2,2V14z"
});

var _ref4 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "gDhs_GJdOvNXmd9k7HRk_b",
  x1: 21.635,
  x2: 27.567,
  y1: 6.417,
  y2: 58.193,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#33bef0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0a85d9"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#gDhs_GJdOvNXmd9k7HRk_b)",
  d: "M6,14v26c0,1.105,0.895,2,2,2h32c1.105,0,2-0.895,2-2V14H6z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M21,23h-2c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v2 C22,22.552,21.552,23,21,23z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M29,23h-2c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v2 C30,22.552,29.552,23,29,23z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M37,23h-2c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v2 C38,22.552,37.552,23,37,23z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M21,30h-2c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v2 C22,29.552,21.552,30,21,30z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13,30h-2c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v2 C14,29.552,13.552,30,13,30z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M29,30h-2c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v2 C30,29.552,29.552,30,29,30z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M21,37h-2c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v2 C22,36.552,21.552,37,21,37z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13,37h-2c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v2 C14,36.552,13.552,37,13,37z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M29,37h-2c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v2 C30,36.552,29.552,37,29,37z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M37,30h-2c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v2 C38,29.552,37.552,30,37,30z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M14,6v3.5c0,0.276-0.225,0.5-0.5,0.5S13,9.776,13,9.5V6h-2v3.5c0,1.378,1.121,2.5,2.5,2.5 S16,10.878,16,9.5V6H14z",
  opacity: 0.05
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5,6v3.5c0,0.551-0.448,1-1,1s-1-0.449-1-1V6h-1v3.5c0,1.103,0.897,2,2,2s2-0.897,2-2V6H14.5z",
  opacity: 0.07
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M35,6v3.5c0,0.276-0.225,0.5-0.5,0.5S34,9.776,34,9.5V6h-2v3.5c0,1.378,1.121,2.5,2.5,2.5 S37,10.878,37,9.5V6H35z",
  opacity: 0.05
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M35.5,6v3.5c0,0.551-0.448,1-1,1s-1-0.449-1-1V6h-1v3.5c0,1.103,0.897,2,2,2s2-0.897,2-2V6H35.5z",
  opacity: 0.07
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fill: "#54daff",
  d: "M34.5,11L34.5,11c-0.828,0-1.5-0.672-1.5-1.5v-5C33,3.672,33.672,3,34.5,3l0,0 C35.328,3,36,3.672,36,4.5v5C36,10.328,35.328,11,34.5,11z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  fill: "#54daff",
  d: "M13.5,11L13.5,11c-0.828,0-1.5-0.672-1.5-1.5v-5C12,3.672,12.672,3,13.5,3h0 C14.328,3,15,3.672,15,4.5v5C15,10.328,14.328,11,13.5,11z"
});

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.7f2da591.svg";
export { ForwardRef as ReactComponent };